import styled, { css } from 'styled-components';
import { layout } from '../../../package.json';

export const Root = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 3rem 2% 0 2%;
`;

export const ContainerSectionHeader = styled.div`
  width: 100%;
`;

export const ContainerSteps = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 0 2%;
  @media (max-width: ${layout.desktop}) {
    max-width: 550px;
  }
`;

interface StepItemProps {
  active?: boolean;
  bShow?: boolean;
}

export const StepItem = styled.div<StepItemProps>`
  
  width: 100%;
  max-width: 240px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  border-top: 1px solid var(--primary);
  border-bottom: 1px solid var(--primary);


  ${props => props.active === true &&
    css`
      background-color: var(--primary);
      margin-left: -8px;
    `}
  
  ${props => props.bShow === true &&
    css`
          background-color:red;
         display: none;
    `}

  span {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    ${props => props.active === false &&
    css`
        color: var(--primary);
      `}

      ${props => props.active === true &&
    css`
        color: #fff;
      `}

    svg {
      font-size: 30px;
      margin-right: 0.5rem;
    }
  }

  div {
    width: 35px;
    height: 35px;
    margin-top: 85px;
    margin-right: -35px;
    border-radius: 3px;
    justify-content: center;
    transform-origin: 0px 0px;
    transform: rotate(-135deg);
    border-left: 1px solid var(--primary);
    border-bottom: 1px solid var(--primary);

    ${props => props.active === true &&
    css`
        background-color: var(--primary);
      `}
  }

  :first-child{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-left: 1px solid var(--primary);
  }

  :last-child{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: 1px solid var(--primary);
  }

  @media (max-width: ${layout.desktop}) {
    max-width: 210px;
  }
  @media (max-width: ${layout.tablet}) {
    max-width: 180px;
  }
  @media (max-width: ${layout.mobile}) {
    max-width: 160px;
  }

`;

export const ContainerSectionBody = styled.div`
margin: 0 auto;
margin-top: 2rem;
height: 100%;
background-color: #F5F5F5;
padding: 2%;
border-radius: 8px;
`;

export const ContainerSectionFooter = styled.div`
  margin-top: 2rem;
  border-radius: 8px;

  margin-bottom: 20px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;

  > div + div {
    margin-left: 1rem;
  }
`;

interface ButtonProps {
  bgColor?: string;
  fgColor?: string;
  disabled?: boolean;
}

export const Button = styled.div<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 1rem 2%;

  ${props => props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `
  }

  span {
    text-align: center;
    font-size: 1.37rem;
    ${props => props.fgColor &&
    css`
          color: ${props.fgColor};
      `}
    font-weight: 800;
  }

  ${props => props.disabled === true &&
    css`
      opacity: 0.5;
      cursor: no-drop;
    `
  }

@media (max-width: ${layout.tablet}) {
    span {
      font-size: 1.15rem;
    }
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 1rem;
    }
  }

`;
